/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Practice_Session_Debrief_FailedInputs */



/**
* | output |
* | --- |
* | "Your feedback could not be written." |
*
* @param {Practice_Session_Debrief_FailedInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const practice_session_debrief_failed = /** @type {((inputs?: Practice_Session_Debrief_FailedInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Practice_Session_Debrief_FailedInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Je feedback kon niet gemaakt worden.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Votre feedback n'a pas pu être préparé.")
	return /** @type {LocalizedString} */ ("Your feedback could not be written.")
});